const Service = (type, action) => {
	let parsed = null;

	switch (type) {
		case "SEND":
			parsed = {
				type: "POST",
				url: "/api/v0.1/feedback/",
				payload: action.feedbackObject,
			};
			break;

		case "EDIT":
			parsed = {
				type: "POST",
				url: `/api/v0.1/feedback/${action.feedbackId}/`,
				payload: action.feedbackObject,
			};
			break;

		case "DELETE":
			parsed = {
				type: "DELETE",
				url: `/api/v0.1/feedback/${action.feedbackId}/`,
			};
			break;

		case "GET":
			parsed = {
				type: "GET",
				url: `/api/v0.1/feedback/${action.feedbackId}/`,
			};
			break;

		case "GETMANY":
			parsed = {
				type: "GET",
				url: `/api/feedback/${action.userId}/?${action.queryString}`,
			};
			break;

		default:
			parsed = null;
			break;
	}

	return parsed;
};

export default Service;
